import React from 'react'

const NoOfferHereIcon = () => (
  <svg
    width="298"
    height="298"
    viewBox="0 0 298 298"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img">
    <path
      d="M245.85 29.502L236.314 25.032L210.984 35.462L86.1221 167.774C86.1221 167.774 89.1021 165.688 93.2741 163.602C97.4461 161.516 98.6381 159.728 101.618 159.728C104.598 159.728 112.942 167.476 123.968 159.728C134.994 151.98 240.248 35.8196 244.062 33.674C247.876 31.5284 246.843 29.9986 245.85 29.502Z"
      fill="#E0E0E0"
    />
    <path
      d="M245.254 165.688C258.914 165.688 269.988 161.819 269.988 157.046C269.988 152.273 258.914 148.404 245.254 148.404C231.593 148.404 220.52 152.273 220.52 157.046C220.52 161.819 231.593 165.688 245.254 165.688Z"
      fill="#E0E0E0"
    />
    <path
      d="M220.228 100.794V146.668L217.982 153.278C217.982 159.309 228.425 164.196 241.306 164.196C254.187 164.196 264.624 159.309 264.624 153.278L262.384 148.099"
      fill="white"
    />
    <path
      d="M220.228 100.794V146.668L217.982 153.278C217.982 159.309 228.425 164.196 241.306 164.196C254.187 164.196 264.624 159.309 264.624 153.278L262.384 148.099"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M241.305 110.662C252.946 110.662 262.383 106.244 262.383 100.794C262.383 95.3441 252.946 90.9259 241.305 90.9259C229.664 90.9259 220.227 95.3441 220.227 100.794C220.227 106.244 229.664 110.662 241.305 110.662Z"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M262.383 146.668C262.383 152.119 252.943 156.536 241.305 156.536C229.667 156.536 220.227 152.119 220.227 146.668"
      fill="white"
    />
    <path
      d="M262.383 146.668C262.383 152.119 252.943 156.536 241.305 156.536C229.667 156.536 220.227 152.119 220.227 146.668"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M262.383 100.794V146.668"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M118.408 156.735C119.875 155.268 136.045 134.978 167.211 102.434C198.377 69.8894 231.015 40.3002 232.78 38.5563L236.894 34.442C236.894 34.442 237.777 32.9695 241.306 29.8315C239.249 24.0516 179.304 1.55835 179.304 1.55835L174.014 7.43739C174.014 7.43739 173.132 10.9671 171.66 13.3167C170.187 15.6663 138.4 56.7838 122.522 75.309C106.644 93.8341 81.6552 123.82 80.752 126.175"
      fill="white"
    />
    <path
      d="M118.408 156.735C119.875 155.268 136.045 134.978 167.211 102.434C198.377 69.8894 231.015 40.3002 232.78 38.5563L236.894 34.442C236.894 34.442 237.777 32.9695 241.306 29.8315C239.249 24.0516 179.304 1.55835 179.304 1.55835L174.014 7.43739C174.014 7.43739 173.132 10.9671 171.66 13.3167C170.187 15.6663 138.4 56.7838 122.522 75.3089C106.644 93.8341 81.6552 123.82 80.752 126.175"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M86.0097 147.065C81.723 142.366 78.9923 136.978 78.9036 132.174C78.7365 123.058 88.1505 119.481 99.9297 124.18C111.709 128.879 121.389 140.074 121.551 149.19C121.713 158.307 112.309 161.888 100.53 157.189C99.3535 156.727 98.2016 156.204 97.0789 155.623"
      fill="white"
    />
    <path
      d="M86.0097 147.065C81.723 142.366 78.9923 136.978 78.9036 132.174C78.7365 123.058 88.1505 119.481 99.9297 124.18C111.709 128.879 121.389 140.074 121.551 149.19C121.713 158.307 112.309 161.888 100.53 157.189C99.3535 156.727 98.2016 156.204 97.0789 155.623"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.1758 138.643C93.1626 137.181 95.5225 136.826 98.3054 137.938C102.013 139.416 105.057 142.94 105.093 145.812C105.123 146.26 105.047 146.709 104.872 147.122C104.697 147.536 104.428 147.902 104.086 148.193"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.1392 167.48C74.4173 166.634 73.9806 165.581 73.8912 164.473C73.8494 162.316 76.0737 161.471 78.8619 162.577C81.65 163.684 83.937 166.337 83.9735 168.493C84.0101 170.65 81.791 171.495 79.0029 170.388"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M76.4964 166.164C76.4014 165.937 76.3484 165.695 76.3398 165.449C76.3398 164.342 77.4625 163.883 78.8931 164.478C80.3237 165.073 81.5038 166.41 81.5038 167.517C81.5038 168.347 80.8772 168.801 79.9374 168.733"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.2795 138.502L74.2295 163.152"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M104.101 148.188L83.6699 169.746"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M177.24 8.7583L234.251 32.3637"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.3"
      d="M71.3408 164.014C68.9495 166.624 72.2962 168.619 73.9879 171.292C76.9379 175.96 72.8078 177.453 66.1924 178.336C59.5771 179.218 34.8649 190.245 26.0566 209.209C23.1484 215.475 2.95653 247.231 32.817 268.842C68.3218 294.531 141.044 298.368 171.134 266.195C207.025 227.823 183.504 195.096 145.577 195.096C108.991 195.096 101.238 185.15 98.4392 181.422C95.6406 177.694 100.742 170.457 96.0374 169.663C91.333 168.87 74.6041 169.141 77.2148 164.792C79.8254 160.442 78.567 159.602 77.9039 159.294C76.6978 158.735 75.5022 159.466 71.3408 164.014Z"
      fill="#AB4F61"
    />
    <path
      d="M73.7246 169.61C71.3333 172.221 74.68 174.215 76.3717 176.889C79.3217 181.557 75.1916 183.05 68.5762 183.932C61.9609 184.815 37.2487 195.842 28.4404 214.806C25.5322 221.071 5.34032 252.828 35.2008 274.439C70.7055 300.127 143.428 303.965 173.518 271.791C209.409 233.42 185.888 200.693 147.961 200.693C111.375 200.693 103.622 190.746 100.823 187.018C98.0244 183.29 103.126 176.054 98.4212 175.26C93.7168 174.466 76.9879 174.738 79.5985 170.388C82.2092 166.039 80.9508 165.198 80.2877 164.89C79.0815 164.332 77.886 165.063 73.7246 169.61Z"
      stroke="#252525"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M159.698 57.4005C159.318 56.7843 158.781 56.2802 158.142 55.9402C157.132 55.3606 155.969 55.1041 154.808 55.2054C153.648 55.3066 152.547 55.7607 151.652 56.5065C150.514 57.4362 149.471 59.0574 149.608 61.8705C149.886 64.9475 151.211 67.8359 153.363 70.0536L158.768 62.669C160.556 60.2254 160.342 58.4972 159.698 57.4244V57.4005ZM161.796 51.8517C160.187 50.9878 158.356 50.6246 156.539 50.8087C155.253 51.0294 154.042 51.5651 153.013 52.368C151.985 53.1708 151.171 54.216 150.645 55.4099C150.478 55.8152 150.329 56.2263 150.198 56.6316C151.066 55.2518 152.267 54.1123 153.69 53.3178C153.922 53.1882 154.163 53.0766 154.411 52.984C154.824 52.8174 155.254 52.6977 155.693 52.6267C155.914 52.579 156.128 52.5491 156.337 52.5193C157.691 52.3524 159.064 52.5909 160.282 53.2046C165.354 55.8807 162.428 60.0586 162.428 60.0586L154.382 71.043C154.656 71.2695 154.93 71.5017 155.222 71.7222L164.299 59.3375C167.643 54.7781 161.796 51.8517 161.796 51.8517ZM176.696 65.1307C175.97 64.8104 175.182 64.6576 174.389 64.6837C172.923 64.7314 170.98 65.3869 169.192 67.8305L163.828 75.197C167.677 75.7238 171.597 75.2201 175.188 73.7369C177.667 72.5926 178.734 71.2395 179.157 70.0952C179.676 68.5992 179.634 66.5194 176.726 65.1307H176.696ZM181.464 57.4482C182.337 57.8658 183.105 58.4748 183.711 59.2301C184.317 59.9854 184.745 60.8675 184.962 61.8108C185.21 63.0383 185.107 64.3109 184.664 65.4823C188.532 58.3303 185.856 49.9861 177.995 46.0942C170.063 42.1845 159.686 44.2228 153.81 50.5642C154.981 49.5637 156.362 48.8389 157.85 48.4427C159.955 47.8197 162.215 47.9957 164.198 48.9372C170.945 52.686 166.433 58.8963 166.433 58.8963L156.432 72.5508C156.742 72.7415 157.028 72.9202 157.368 73.099L168.054 58.509C169.472 56.572 170.194 54.4266 169.717 52.3048C169.476 51.2685 169.007 50.2989 168.344 49.4668C167.681 48.6348 166.841 47.9611 165.884 47.4949C167.638 46.6192 169.558 46.1275 171.517 46.0526C173.482 45.96 175.439 46.3553 177.214 47.203C178.845 47.9814 180.207 49.2259 181.13 50.779C181.951 52.2279 182.33 53.8853 182.221 55.547C180.111 54.5901 177.737 54.3799 175.492 54.951C173.011 55.5668 170.831 57.0458 169.341 59.123L158.673 73.695C159.019 73.85 159.358 73.9872 159.71 74.1243L169.705 60.4759C169.705 60.4759 174.27 54.2954 181.464 57.4244V57.4482ZM183.025 63.8433C182.561 62.7288 181.518 61.5486 179.449 60.5295C179.449 60.5295 173.561 57.6567 170.223 62.2101L161.152 74.601C161.522 74.7082 161.897 74.8036 162.285 74.887L170.319 63.9149C170.319 63.9149 173.448 59.8381 178.704 62.2578C179.837 62.7773 180.754 63.6751 181.297 64.7969C181.368 64.9664 181.429 65.1393 181.482 65.3152C181.621 65.6644 181.693 66.0364 181.696 66.4121C181.717 66.6381 181.717 66.8653 181.696 67.0913C181.475 68.567 180.836 69.9487 179.855 71.0727C180.425 70.6369 180.97 70.1692 181.488 69.672C183.818 67.1271 183.389 64.7969 183.055 63.8433"
      fill="#252525"
    />
  </svg>
)

export default NoOfferHereIcon
export { NoOfferHereIcon }
